import {NgModule} from '@angular/core';
import {WindowSizeService} from './services/window-size/window.size.service';

@NgModule({
	providers: [
		WindowSizeService
	]
})
export class KCoreModule {
}
